
import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { db } from "./db";

export const fillArticleSpecsDB = () => {
    return db.articlesSpec.count(async function (count: number) {
        if (count > 0) {
            //ArticlesSpec already populated
        } else {
            //ArticlesSpec Database is empty. Populating from ajax call...
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticleSpecs()
                .then((data) => {
                    //Got ajax response. We'll now add the objects.
                    //Calling bulkAdd() to insert objects...
                    if (data) {
                        return db.articlesSpec.bulkAdd(data);
                    }
                })
                .then(() => {
                    //Done populating.
                    return db.timestamps.add({ name: "articlesSpec", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const deleteArticleSpecsTable = async () => {
    return db.articlesSpec.clear().then(() => {
        //Database successfully cleared
    }).catch((err) => {
        //Could not clear database
    })
}

export const updateArticleSpecsTable = async () => {
    await ArticleService.getArticleSpecs()
        .then(async (data) => {
            await deleteArticleSpecsTable().then(async () => {
                //@ts-ignore
                return db.articlesSpec.bulkAdd(data);
            })
        })
        .then(() => {
            //Done refilling.
            return db.timestamps.put({ name: "articlesSpec", timestamp: String(new Date()) })
        })
        .catch(err => console.log(err));
}


